import { render, staticRenderFns } from "./RewardsPointsPopup.vue?vue&type=template&id=4fc33b26"
import script from "./RewardsPointsPopup.vue?vue&type=script&lang=js"
export * from "./RewardsPointsPopup.vue?vue&type=script&lang=js"
import style0 from "./RewardsPointsPopup.vue?vue&type=style&index=0&id=4fc33b26&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports